import { apiInitAdyen } from '../requests'
import {
  initAdyenCheckout,
  apiInitAdyenStart,
  apiInitAdyenSuccess,
  apiInitAdyenFail,
} from './actions'

export const operationProcessAdyenCheckoutResponse = (response) => (dispatch) => {
  const {
    pageAttributes: { action, ...config },
  } = response
  const adyenAction = JSON.parse(action)
  dispatch(initAdyenCheckout({ action: adyenAction, config }))
}

export const operationApiInitAdyen = () => async (dispatch: any) => {
  dispatch(apiInitAdyenStart())

  try {
    const response = await apiInitAdyen()
    dispatch(apiInitAdyenSuccess({ config: response }))
  } catch (error) {
    dispatch(apiInitAdyenFail(error))
  }
}
